import { getDeviceTopMessage } from '@/api';
import { useRequest } from 'ahooks';
import { Card, Empty, Modal, Progress, Typography } from 'antd';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './DeviceMessageRanking.less';
import { RightOutlined } from '@ant-design/icons';
import { useQuery } from '@tanstack/react-query';

const { Title } = Typography;

interface DeviceRankingItem {
  id: string;
  device_name: string;
  count: number;
}

function DeviceMessageRankingModal() {
  const [open, setOpen] = useState(false);
  const { data } = useQuery({
    queryKey: ['deviceMessageRanking'],
    queryFn: () => getDeviceTopMessage(50),
    enabled: open,
    select: (data) => data?.result || [],
  });
  console.log({ data });

  const navigate = useNavigate();
  const handleDeviceNameClick = (deviceId: string) => {
    navigate(`/gateway/device/detail/${deviceId}`);
  };
  return (
    <>
      <Modal
        width={'80%'}
        footer={null}
        open={open}
        onCancel={() => setOpen(false)}
        title={
          <>
            <div style={{ fontSize: 14, color: '#3D3D3D', marginBottom: 4 }}>设备消息量排名TOP-50</div>
            <div style={{ color: '#9CA3AF', fontWeight: 'normal', fontSize: 12 }}>统计当日设备属性上报数量排名</div>
          </>
        }
      >
        {!data?.length && <Empty></Empty>}
        <div className="" style={{ maxHeight: 'calc(100vh - 240px)', padding: '20px 10px', overflowY: 'auto' }}>
          {data?.map((item: DeviceRankingItem) => (
            <div
              key={item.id}
              className="flex "
              onClick={() => {
                handleDeviceNameClick(item.id);
              }}
              style={{ alignItems: 'center', gap: 20, marginBottom: 20, color: '#3D3D3D;', fontSize: 14, paddingRight: 10, cursor: 'pointer' }}
            >
              <div
                className=""
                title={item.device_name}
                style={{ width: '140px', flex: 'none', textAlign: 'right', marginRight: 30, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
              >
                {item.device_name}
              </div>
              <Progress size={[32, 10]} className="flex-auto" steps={16} format={() => ''} percent={(item.count / data?.[0]?.count) * 100}></Progress>
              <div className="" style={{ textAlign: 'left', flex: 'none' }}>
                {item.count}条
              </div>
            </div>
          ))}
        </div>
      </Modal>
      <Title style={{ marginBottom: 0, fontSize: '16px' }} level={3} onClick={() => setOpen(true)}>
        <div className="flex items-center justify-between w-full cursor-pointer" style={{ width: '100%', justifyContent: 'space-between', cursor: 'pointer' }}>
          设备消息量排名
          <RightOutlined />
        </div>
      </Title>
    </>
  );
}

const DeviceMessageRanking: React.FC = () => {
  const navigate = useNavigate();
  const { data, loading } = useRequest(() => getDeviceTopMessage(5));
  const [mousePosition, setMousePosition] = useState<{ x: number; y: number; text: string } | null>(null);

  // 格式化设备名称：超过4个字显示省略号
  const formatDeviceName = (name: string) => {
    if (name.length > 4) {
      return name.substring(0, 4) + '...';
    }
    return name;
  };

  // 处理设备名称点击，跳转到设备详情页面
  const handleDeviceNameClick = (deviceId: string) => {
    navigate(`/gateway/device/detail/${deviceId}`);
  };

  // 处理鼠标移动 - 设备名称
  const handleDeviceNameMouseMove = (e: React.MouseEvent, deviceName: string) => {
    setMousePosition({ x: e.clientX, y: e.clientY, text: deviceName });
  };

  // 处理鼠标移动 - 方格
  const handleProgressMouseMove = (e: React.MouseEvent, count: number) => {
    setMousePosition({ x: e.clientX, y: e.clientY, text: `设备消息数量: ${count}` });
  };

  // 处理鼠标离开
  const handleMouseLeave = () => {
    setMousePosition(null);
  };

  const displayData = data?.result === null || data?.result === undefined ? null : data?.result || [];

  return (
    <Card title={<DeviceMessageRankingModal />} className="message-line-card device-message-ranking-card" style={{ height: '100%', display: 'flex', flexDirection: 'column' }} loading={loading}>
      {displayData === null ? (
        <div style={{ textAlign: 'center', padding: '40px 0', color: '#999', flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>无数据</div>
      ) : (
        <div className="device-message-ranking__list">
          {displayData.slice(0, 5).map((item, index) => {
            // 格子数量从上到下依次减1：第一个5个(100%)，第二个4个(80%)，第三个3个(60%)...
            // 使用 percent 来控制填充的格子数量，steps=5
            const percent = (5 - index) * 20;

            return (
              <div key={item.id} className="device-message-ranking__item">
                <div
                  className="device-message-ranking__device-name"
                  onClick={() => handleDeviceNameClick(item.id)}
                  onMouseMove={(e) => handleDeviceNameMouseMove(e, item.device_name)}
                  onMouseLeave={handleMouseLeave}
                >
                  {formatDeviceName(item.device_name)}
                </div>
                <div className="device-message-ranking__progress-wrapper" onMouseMove={(e) => handleProgressMouseMove(e, item.count)} onMouseLeave={handleMouseLeave}>
                  <Progress type="line" percent={percent} steps={5} showInfo={false} strokeColor="#5B8FF9" />
                </div>
              </div>
            );
          })}
        </div>
      )}
      {mousePosition && (
        <div
          className="device-message-ranking__tooltip"
          style={{
            position: 'fixed',
            left: `${mousePosition.x}px`,
            top: `${mousePosition.y - 35}px`,
            transform: 'translateX(-50%)',
            pointerEvents: 'none',
            zIndex: 9999,
          }}
        >
          {mousePosition.text}
        </div>
      )}
    </Card>
  );
};

export default DeviceMessageRanking;
